import { takeLatest, put } from 'redux-saga/effects';

import api from 'apiSingleton';

import * as actionTypes from 'redux/payment/actionTypes';
import { setPaymentErrorToStore } from 'redux/payment/actions';

import { IPaymentFailToReteno } from 'types/payments/paymentApiInterfaces';

export function* sendPaymentFailToReteno({ payload }: ReturnType<typeof setPaymentErrorToStore>) {
    try {
        const response: IPaymentFailToReteno = yield api.payment.paymentFailToReteno(payload);

        yield put(setPaymentErrorToStore(response));
    } catch ({ error }) {
        console.error('error', error);
    }
}

export const setPaymentErrorCodeToReteno = [takeLatest(actionTypes.SET_PAYMENT_RETENO_ERROR, sendPaymentFailToReteno)];
